// extracted by mini-css-extract-plugin
module.exports = {"root":"subfeatures_root__3KAVo","outer":"subfeatures_outer__Z_5vC","handwritingWrapper":"subfeatures_handwritingWrapper__2nIID","inner":"subfeatures_inner__1iOqF"};